"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNil = _interopRequireDefault(require("./isNil"));

var passThrough = function passThrough(value) {
  return value;
};
/**
 * Iterates the keys of an Object then assigns the key/value pair to a Map
 * @param {Object} inObject
 * @param {function} mappingFunction
 * @returns {Map<any, any>}
 */


var convertObjectToMap = function convertObjectToMap(inObject) {
  var mappingFunction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : passThrough;
  // TODO is this the correct behavior here?
  if ((0, _isNil["default"])(inObject)) return null;
  var keys = Object.keys(inObject);
  var result = new Map();
  keys.forEach(function (key) {
    result.set(key, mappingFunction(inObject[key]));
  });
  return result;
};

var _default = convertObjectToMap;
exports["default"] = _default;